import { BinPeopleCounter } from "./state";

export function initBinPeopleCounterListAction(binPeopleCounterList: BinPeopleCounter[]) {
  return {
    type: '@@PeopleCounterState/initBinPeopleCounterListAction' as const,
    binPeopleCounterList
  }
}

export function initTargetBinPeopleCounterAction(targetBinPeopleCounter: BinPeopleCounter) {
  return {
    type: '@@PeopleCounterState/initTargetBinPeopleCounterAction' as const,
    targetBinPeopleCounter
  }
}

export function clearTargetBinPeopleCounterAction() {
  return {
    type: '@@PeopleCounterState/clearTargetBinPeopleCounterAction' as const
  }
}

export function changeTargetBinPeopleCounterAction(binPeopleCounter: number) {
  return {
    type: '@@PeopleCounterState/changeTargetBinPeopleCounterAction' as const,
    binPeopleCounter
  }
}

export type PeopleCounterAction =
  | ReturnType<typeof initBinPeopleCounterListAction>
  | ReturnType<typeof initTargetBinPeopleCounterAction>
  | ReturnType<typeof clearTargetBinPeopleCounterAction>
  | ReturnType<typeof changeTargetBinPeopleCounterAction>
